import React from 'react';
import './index.css';

export default ({ onChange }) => {
  return (
    <div class="theme-switch-wrapper">
      <label class="theme-switch" for="checkbox">
        <input type="checkbox" id="checkbox" onChange={onChange}/>
        <div class="slider round"></div>
      </label>
        <h5>Toggle Dark Mode</h5>
    </div>
  )
};


// WEBPACK FOOTER //
// ./src/components/Toggle/index.js